import { Check } from "lucide-react";

const STEPS = [["searching", "Searching"], ["accepted", "Accepted"], ["arrived", "Arrived"], ["in_progress", "In progress"], ["completed", "Completed"]];
const DELIVERY_STEPS = [["searching", "Searching"], ["accepted", "Accepted"], ["arrived", "At store"], ["in_progress", "Picked up"], ["completed", "Delivered"]];

export const StatusTimeline = ({ status, kind }) => {
  const steps = kind === "delivery" ? DELIVERY_STEPS : STEPS;
  const idx = steps.findIndex(([k]) => k === status);
  return (
    <ol data-testid="trip-status-timeline" className="grid grid-cols-5 gap-1">
      {steps.map(([key, label], i) => {
        const done = i < idx || status === "completed";
        const current = i === idx && status !== "completed";
        return (
          <li key={key} data-testid={`timeline-step-${key}`} data-state={done ? "done" : current ? "current" : "todo"} className="flex flex-col items-center text-center">
            <div className="flex w-full items-center">
              <span className={`h-px flex-1 ${i === 0 ? "opacity-0" : i <= idx ? "bg-amber-400/70" : "bg-zinc-800"}`} />
              <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-[11px] font-semibold transition-colors duration-500 ${done ? "border-amber-400 bg-amber-400 text-black" : current ? "border-amber-400 text-amber-300 shadow-[0_0_0_4px_rgba(212,175,55,0.15)]" : "border-zinc-700 text-zinc-600"}`}>
                {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
              </span>
              <span className={`h-px flex-1 ${i === STEPS.length - 1 ? "opacity-0" : i < idx ? "bg-amber-400/70" : "bg-zinc-800"}`} />
            </div>
            <span className={`mt-2 text-[10px] leading-tight sm:text-xs ${current ? "text-amber-200" : done ? "text-zinc-300" : "text-zinc-600"}`}>{label}</span>
          </li>
        );
      })}
    </ol>
  );
};
